import { PagedResponse } from './../../interfaces/paged-response.inteface';
import { ApiController } from './../api-controller.interface';
import { environmentv3 } from 'src/environments/environmentv3';
import { Injectable } from '@angular/core';
import { IFilter } from 'sol-request-angular/dist/comunicacao/interfaces/IFilter';
import { Feriado } from '@tivic-team/manager-ts/dist/grl/entities/feriado.entity';
import { HttpGet, HttpPost, HttpPut, HttpResponse, JSONData, Quark, Url } from 'sol-request-angular/dist/comunicacao';

@Injectable()
export class FeriadoController implements ApiController<Feriado> {
    
    constructor () {}

    find(filters?: IFilter): Promise<PagedResponse<Feriado>> {
        let request = new Quark(
            new HttpGet ({
                url: new Url({
                    id: 'grl/feriados',
                    environment: environmentv3,
                    filter: filters,
                }),
            }),
            new HttpResponse({})
        );
        return request.call();
    }

    get(id: number): Promise<Feriado> {
        let request = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'grl/feriados/:cdFeriado',
                    environment: environmentv3,
                    pathParams: new JSONData({
                        cdFeriados: id
                    }),
                }),
            }),
            new HttpResponse(new Feriado)
        );
        return request.call();
    }

    create(entity: Feriado): Promise<Feriado> {
        let request = new Quark (
            new HttpPost({
                url: new Url({
                    id: 'grl/feriados',
                    environment: environmentv3
                }),
                data: new JSONData(entity)
            }),
            new HttpResponse(
                new Feriado()
            )
        );
        return request.call();
    }
    
    update(entity: Feriado): Promise<Feriado> {
        let request = new Quark(
            new HttpPut({
                url: new Url({
                    id: 'grl/feriados/:cdFeriado',
                    environment: environmentv3,
                    pathParams: new JSONData({
                        cdFeriado: entity.cdFeriado
                    }),
                }),
                data: new JSONData(entity)
            }),
            new HttpResponse(
                new Feriado()
            )
        );
        return request.call();
    }
}